import React from 'react';
import { Button } from './ui/button';
import { Phone } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-600 via-blue-700 to-cyan-600">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-bold text-white mb-4">Ready to Get Started?</h2>
        <p className="text-xl text-blue-50 mb-8">
          Let's discuss how we can help your organization with reliable, security-first IT support.
        </p>

        <div className="flex justify-center mb-6">
          <a href="tel:+17746447101">
            <Button 
              size="lg" 
              className="bg-white text-blue-600 hover:bg-gray-100 shadow-xl px-8"
            >
              <Phone className="w-5 h-5 mr-2" />
              Call Now: 774-644-7101
            </Button>
          </a>
        </div>

        <p className="text-sm text-blue-100 flex items-center justify-center">
          <span className="inline-block w-2 h-2 bg-white rounded-full mr-2"></span>
          We respond within 1 business day (often faster). Emergency support available.
        </p>
      </div>
    </section>
  );
};

export default CTASection;